import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { canUserAccessGiphyAndUnsplash } from 'common/store/userProperties/selectors';
import BaseComponent, { transferProps } from 'common/components/BaseComponent';
import { SuiModal } from '@splashthat/sui';

import * as actions from '../../actions';
import ImageUploader from './ImageUploader';

class ImageUploaderModal extends BaseComponent {
    static propTypes = {
        className: PropTypes.string,
        open: PropTypes.bool.isRequired,
        closeImageUploader: PropTypes.func.isRequired,
        onImageSelected: PropTypes.func.isRequired,
        onAsyncUploadToCdnStart: PropTypes.func.isRequired,
        onAsyncUploadToCdnFail: PropTypes.func.isRequired,
        availableTabs: PropTypes.arrayOf(PropTypes.string),
    };
    static defaultProps = {
        availableTabs: [],
    };

    static defaultProps = {
        useClickOutside: true,
    };

    static tagName = SuiModal;

    get baseClassName() {
        return 'ImageUploaderModal';
    }

    onImageSelected = (imageUrl, closeModal = true, fileExtension = null) => {
        this.props.onImageSelected(imageUrl, fileExtension);
        if (closeModal) {
            this.props.closeImageUploader();
        }
    };

    onAsyncUploadToCdnStart = (imageUrl) => {
        this.props.onAsyncUploadToCdnStart(imageUrl);
        this.props.closeImageUploader();
    };

    transferProps(props, tagName, omitTransferProps) {
        const transferredProps = transferProps(props, tagName, omitTransferProps);
        return {
            ...transferredProps,
            size: SuiModal.WIDE,
        };
    }

    propChildren(props, baseClassName) {
        return (
            <ImageUploader
                {...props}
                variation="border standard flex-vertical"
                onImageSelected={this.onImageSelected}
                onAsyncUploadToCdnStart={this.onAsyncUploadToCdnStart}
            />
        );
    }
}

const mapStateToProps = (state, props) => {
    const { imageUploader } = state;

    const {
        onImageSelected,
        closeImageUploader,
        onRequestClose = closeImageUploader,
        onAsyncUploadToCdnStart = onImageSelected,
        onAsyncUploadToCdnFail = closeImageUploader,
    } = props;

    return {
        ...imageUploader,
        ...props,
        onRequestClose,
        onAsyncUploadToCdnStart,
        onAsyncUploadToCdnFail,
        canUserAccessGiphyAndUnsplash: canUserAccessGiphyAndUnsplash(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) =>
    bindActionCreators(
        {
            ...actions,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(ImageUploaderModal);
